export default __webpack_public_path__ + "static/media/walletlink-alternative.b7bb8286.png";